import * as Yup from 'yup';
import { emailValidation } from '../../../helpers';

export const validationSchema = Yup.object().shape({
  email: emailValidation(),
});
